(function ($) {
    var callbacks = [];

    window.lazyContent = {
        bindCallback: function (callback) {
            callbacks.push(callback);
        }
    };

    $(function () {

        var lazyContentUrls = [];
        var lazyContent = {};

        $('.lazy-content').each(function (i, el) {
            var $el = $(el);

            var url = $el.data('url');

            var urlIndex = lazyContentUrls.indexOf(url);
            if (urlIndex === -1) {
                lazyContentUrls.push(url);
                urlIndex = lazyContentUrls.indexOf(url);
                lazyContent[urlIndex] = {
                    callbacks: []
                }
            }

            lazyContent[urlIndex].callbacks.push(function (data) {
                $el.html(data);
                $el.removeClass('lazy-content');
            });
        });

        lazyContentUrls.forEach(function (url, index) {
            $.ajax({
                url: url
            }).done(function (data) {
                function callCallbacksWithData(callback) {
                    callback(data);
                };
                lazyContent[index].callbacks.forEach(callCallbacksWithData);
                callbacks.forEach(callCallbacksWithData);
            });
        });
    });

})(jQuery);